module.exports = __webpack_public_path__ + "components/flag/static/square/hu-a6746ab6c9424942708577439c9f9769.svg";